import { gql } from '@apollo/client';

export const CREATE_COUNTRY_MUTATION = gql`
  mutation createCountry(
    $name: String!
    $code2: String!
    $code3: String!
    $regionId: Int!
  ) {
    createCountry(
      name: $name
      code2: $code2
      code3: $code3
      regionId: $regionId
    ) {
      country {
        id
        currentVersion {
          id
          name
        }
      }
    }
  }
`;

export const ADD_COUNTRY_VERSION_MUTATION = gql`
  mutation addVersionToCountry(
    $countryId: Int!
    $name: String!
    $code2: String!
    $code3: String!
    $regionId: Int!
    $publish: Boolean
  ) {
    addVersionToCountry(
      countryId: $countryId
      name: $name
      code2: $code2
      code3: $code3
      regionId: $regionId
      publish: $publish
    ) {
      countryVersion {
        id
        name
      }
    }
  }
`;

export const EDIT_COUNTRY_VERSION_MUTATION = gql`
  mutation editDraftCountryVersion(
    $countryId: Int!
    $name: String
    $code2: String
    $code3: String
    $publish: Boolean
  ) {
    editDraftCountryVersion(
      countryId: $countryId
      name: $name
      code2: $code2
      code3: $code3
      publish: $publish
    ) {
      countryVersion {
        code2
        code3
        countryId
        createdById
        id
        name
        regionId
        status
        updatedById
        version
      }
    }
  }
`;
